"use client";

import { createContext, useContext } from "react";
import { DEFAULT_CONTENT } from "@/lib/content/defaults";
import type { SiteContent } from "@/lib/content/types";

export const ContentContext = createContext<SiteContent>(DEFAULT_CONTENT);

export const useContent = () => useContext(ContentContext);
